export enum Sort {
  asc = "asc",
  desc = "desc"
}

export interface ISort {
  sort: Sort;
  field: string;
}

export interface IDrawerData {
  titleProperty: string,
  overview: ITableDrawerDataOverview,
  details?: ITableDrawerDataOverview,
}

interface ITableDrawerDataOverview {
  [field: string]: {
    key: string;
    hidden?: boolean;
    transform?: (value: number) => string,
    expandable?: boolean,
    notBold?: boolean
  }
}

export interface IOnTableChangeArgs {
  filterState?: any,
  filters?: any,
  page: number,
  pageSize: number,
  search: string,
  sort: ISort[]
}

export interface ITableColumn {
  default?: boolean;
  defaultSort?: ISort | Sort;
  field: string;
  flex?: number;
  headerName: string;
  isSettings: boolean;
  minWidth: number;
  renderCell: any;
  sortable: boolean;
  disableReorder: boolean;
  tooltip: string | false;
  width: number;
  valueFormatter: any;
  isLocked?: boolean;
  hidden: boolean;
}

export type TableColumn = Partial<ITableColumn>

interface IRadioGroupFilterProps {
  label: string,
  name: string,
  options: IRadioGroupOption[],
  currentValue: any
}

export interface IRadioGroupOption {
  label: string;
  value: any;
}
